import { useQuery } from "react-query";
import { TTotalFilters } from "../types";
import { getMailBoxEmails } from "./gateway";
import { queryClient } from "src/shared/services/QeuryClient/reactQueryClient";
function useGetMailBoxEmails(totalFilters: TTotalFilters) {
  return useQuery({
    queryFn: () => getMailBoxEmails(totalFilters),
    queryKey: ["getMailBoxEmails", totalFilters],
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["unreadEmailCount"] });
    },
  });
}

export default useGetMailBoxEmails;
